export class HttpError extends Error {
  public status: number;
  public data: any;
}
